import { createAsyncThunk } from "@reduxjs/toolkit";
import { type QueueDeliveryDetail } from "../../../domain/entities/assignment-queue";
import { type RouteAssignmentDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getDeliveryDetail = createAsyncThunk<
  QueueDeliveryDetail,
  string,
  { dispatch: RouteAssignmentDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_DELIVERY_DETAIL, async (requestId, { extra }) => {
  return await extra.routeAssignmentRepo.getDeliveryDetail(requestId);
});
